import script from "./SendingGlobal.vue?vue&type=script&setup=true&lang=js"
export * from "./SendingGlobal.vue?vue&type=script&setup=true&lang=js"

import "./SendingGlobal.vue?vue&type=style&index=0&id=f2dd274e&lang=css"

const __exports__ = script;

export default __exports__